<template>
  <div class="page-pod-detail">
    <pdrs-detail />
  </div>
</template>

<script>
import PdrsDetail from '@/components/ask/details/PdrsDetail.vue'

export default {
  name: 'ViewPodsDetail',
  components: {
    PdrsDetail,
  },

  data() {
    return {
      pageName: 'PdrsDetail',
    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },
  
}
</script>
